import {default as router, adminRouters} from "./router";
import {getToken,removeToken,getCurrentTitle} from '@/utils/auth' // get token from cookie
import {getAcctInfo, getAcctMenus} from './api/login'
import store from './store'

const whiteList = ['/', '/admin-login'] // no redirect whitelist

console.log(router)

router.beforeEach((to, from, next) => {
  console.log("router beforeEach", to, from)
  store.dispatch('setProgress', true)

  let urlArr=GetRequest();
  console.log(urlArr,'urlArr');

  if(urlArr.tk){
    // alert('tk');
    removeToken();
    store.dispatch('logIn',urlArr.tk).then(() => {
    });
  }
  if (getToken()) {
    // 是否获取到账户信息（刷新后就需要重新获取）
    if (!store.getters.acctLoaded) {
      // 获取账户信息
      getAcctInfo().then(res => {
        if (res.isAdmin) {
          store.dispatch('acctInfoSet', {isAdmin: res.isAdmin, acctName: '超级管理员', compName: '棕旨医疗科技'})
          // admin 权限不需要在请求后台
          console.log("next", {...to, replace: true})
          store.dispatch('setProgress', false)
          store.dispatch('setRouters', adminRouters[0].children) // admin只有一层 写死[0]
          router.addRoutes(adminRouters) // 动态添加可访问路由表
          next({...to, replace: true})// hack方法 确保addRoutes已完成
        } else {
          store.dispatch('acctInfoSet', {isAdmin: res.isAdmin, acctName: res.acctVO.acctName, compName: res.acctVO.compName})
          // 向后台请求权限（路由）信息。
          getAcctMenus().then(res => {
            store.dispatch('setProgress', false)
            let routers = transMenuToRouter(res)
			console.log(routers,"routersrouters")
			console.log(routers[0].children)
			routers[0].children.forEach((val,index)=>{
				console.log(val.path)
				// if(val.path !='/data-platform'){
				//   next({path:'/h-mon-lg-scrn', replace: true})
				// }else
				// if(val.path ==='/data-platform'){
				// 	next({path:'/data-platform', replace: true})
				// }else{
				// 	next({...to, replace: true})
				// }
			})
			
            store.dispatch('setRouters', routers)
            router.addRoutes(routers)
			console.log(to.path,'to.pathto.pathto.pathto.pathto.pathto.pathto.path')
			var rintoken = '/data-platform?tk='+getToken()
            if(to.path == "/"){
				routers[0].children.forEach((val,index)=>{
					console.log(val.path,"sdasdsadsdasdsd")
					if(val.path !='/data-platform'){
					  next({path:'/h-mon-lg-scrn', replace: true})
					}else{
						 next({path:'/data-platform', replace: true})
					}
					
				})
              // next({path:'/data-platform', replace: true})
            }else{
              next({...to, replace: true})
            }
            if(getCurrentTitle()){
              store.dispatch('setCurretTitle', getCurrentTitle())
            }
          }).catch(err => {
            store.dispatch('setProgress', false)
          })
        }

      }).catch(err => {
        store.dispatch('setProgress', false)
        console.log(err)
      })
    } else {
      store.dispatch('setProgress', false)
      // // 如果有tk，检查权限是否拉取
      // if (!store.getters.routerLoaded) {
      //   if (store.getters.isAdmin) {
      //     store.dispatch('setProgress', false)
      //     router.addRoutes(adminRouters) // 动态添加可访问路由表
      //     next({...to, replace: true})// hack方法 确保addRoutes已完成
      //   } else {
      //     console.log("is not admin")
      //     // 向后台请求权限（路由）信息。
      //     getAcctMenus().then(res => {
      //       store.dispatch('setProgress', false)
      //       let routers = transMenuToRouter(res)
      //       store.dispatch('setRouters', routers)
      //       router.addRoutes(routers)
      //       next({...to, replace: true})
      //     }).catch(err => {
      //       store.dispatch('setProgress', false)
      //     })
      //   }
      // } else {
      //   console.log('store.getters.routerLoaded:next')
      //   store.dispatch('setProgress', false)
      //   next()
      // }
      next()
    }

  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // 否则回到首页
      if (to.path.indexOf('\/admin') == 0) {
        next(`/admin-login?redirect=${to.path}`) // 否则全部重定向到登录页
      } else {
        // 否则全部重定向到iMES
        if(process.env.NODE_ENV=='development'||window.location.host.indexOf("test")!=-1){
          window.location.href='http://hosp-test.zzitec.com/#/';
        }else{
          window.location.href='http://hosp.zzitec.com/#/';
        }
      }
    }
    store.dispatch('setProgress', false)

  }
})

// 如果要加默认layout,在这补充
function transMenuToRouter(menus) {
  let routers = []
  let routersAll=[]
  menus.forEach(menu => {
    routers.push({
      path: menu.path,
      name: menu.component,
      component: () => import(`@/views/${menu.component}`),
      meta: { title: menu.menuName }
    })
  })
  routersAll=[{
    path: '/layout',
    name: 'Layout',
    component: () => import('@/views/Layout'),
    children:routers
  }]
  return routersAll;
}


function GetRequest() {
  var url = window.location.href; //获取url中"?"符后的字串
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var urls=url.split("?");
    var str = urls[1];
    var strs = str.split("&");
    for(var i = 0; i < strs.length; i ++) {
      theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}
